// extracted by mini-css-extract-plugin
export default {"signUpModal":"Signup_signUpModal__Fvh-y","modalClose":"Signup_modalClose__Dxc6v"};